import React, { useImperativeHandle, useState } from 'react';
import { Modal, Button } from '@drip/drip-design';
import env from '@/env';

function NoPowerModal(props: any, ref: any) {
  const [noAuthModalVisible, setNoAuthModalVisible] = useState(false);
  const [noPowerInfo, setNoPowerInfo] = useState();
  const [resCode, setResCode] = useState();

  const jumpToNopowerPage = () => {
    if ((window as any).__OSW_ENVIRONMENT__) {
      (window as any).$osw?.goApplyAuth({
        url: `/account-permission/apply-permission?refResCode=${resCode}`, // 必传，即上面截图中对应的资源码，多个用英文逗号分开
      });
    } else {
      window.open('/system/authSetting');
    }
  };

  useImperativeHandle(ref, () => {
    return {
      show: (params: any) => {
        setNoAuthModalVisible(true);
        setNoPowerInfo(params?.noPowerInfo);
        setResCode(params?.resCode);
      },
    };
  });

  const onCancel = () => {
    setNoAuthModalVisible(false);
    setNoPowerInfo(undefined);
    setResCode(undefined);
  };

  return (
    <Modal visible={noAuthModalVisible} footer={null} onCancel={onCancel}>
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          textAlign: 'center',
        }}
      >
        <div>
          <img
            style={{ width: '120px', height: '120px', marginTop: '24px' }}
            src="https://img10.360buyimg.com/img/jfs/t1/268588/3/19804/42618/67af0d4dF9e2650b8/a6fd45a7671c9d32.png"
          ></img>
        </div>
        <h3>{noPowerInfo || '对不起，您没有权限使用该功能'}</h3>
        <div
          style={{
            marginTop: '20px',
          }}
        >
          <Button type="primary" onClick={jumpToNopowerPage}>
            立即申请
          </Button>
        </div>
      </div>
    </Modal>
  );
}

export default React.forwardRef(NoPowerModal);
